import React from 'react'

import Base from '../_Base'

const Universal16 = (props) => (
  <Base width="38" height="22" viewBox="0 0 38 22" fill="none" {...props}>
    <path
      d="M3.701 1.642A2 2 0 0 1 5.67 0h29.935a2 2 0 0 1 1.967 2.358l-3.272 18A2 2 0 0 1 32.33 22H2.396A2 2 0 0 1 .43 19.642l3.272-18Z"
      fill="#4A4E58"
      fillOpacity=".7"
    />
    <path
      d="M12.488 6.818 10.798 17H8.952l1.392-8.387h-.06L7.65 10.134l.279-1.69 2.804-1.626h1.755ZM17.186 17.14a3.997 3.997 0 0 1-1.422-.264 2.716 2.716 0 0 1-1.138-.84c-.315-.392-.532-.91-.652-1.557-.116-.646-.094-1.441.065-2.386.146-.862.364-1.626.656-2.292.292-.67.646-1.236 1.064-1.7.418-.468.887-.82 1.407-1.06a3.948 3.948 0 0 1 1.685-.362c.64 0 1.192.126 1.656.378.464.248.817.59 1.059 1.024.245.43.36.921.343 1.472h-1.78c-.01-.395-.133-.706-.368-.935-.235-.229-.572-.343-1.009-.343-.713 0-1.322.308-1.83.925-.507.613-.858 1.473-1.054 2.58l.08-.105c.212-.291.46-.538.746-.74a3.36 3.36 0 0 1 1.959-.622c.613 0 1.14.15 1.58.448.441.295.761.699.96 1.213.202.513.247 1.1.134 1.76a4.05 4.05 0 0 1-2.188 2.968c-.583.295-1.234.44-1.953.437Zm.064-1.492c.372 0 .721-.091 1.05-.274.331-.185.61-.436.835-.75.228-.315.373-.667.432-1.054a1.83 1.83 0 0 0-.08-.94 1.365 1.365 0 0 0-.516-.666c-.239-.163-.532-.244-.88-.244-.279 0-.549.055-.81.164a2.61 2.61 0 0 0-1.248 1.109 2.357 2.357 0 0 0-.284.795c-.053.342-.026.653.08.935.109.278.285.502.527.671.245.17.543.254.894.254ZM25.762 15.36l1.133-6.881h1.567l-1.139 6.88h-1.561Zm-2.227-2.66.263-1.557h6.88l-.263 1.557h-6.88Z"
      fill="#BBB"
    />
  </Base>
)

export default Universal16
